var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophoneMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2090_104323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 15.7368C14.4186 15.7368 15.5629 14.5334 15.5629 13.0526L15.5714 7.68421C15.5714 6.19895 14.4229 5 13 5C11.5814 5 10.4286 6.19895 10.4286 7.68421V13.0526C10.4286 14.5334 11.5814 15.7368 13 15.7368ZM17.5429 13.0526C17.5429 15.7368 15.37 17.6158 13 17.6158C10.6343 17.6158 8.45714 15.7368 8.45714 13.0526H7C7 16.1082 9.33143 18.6313 12.1429 19.0653V22H13.8571V19.0653C16.6686 18.6313 19 16.1082 19 13.0526H17.5429Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2090_104323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneMuted);
export default __webpack_public_path__ + "static/media/microphone_muted.bdd674bf9dce09d3ac3e622c29a4c495.svg";
export { ForwardRef as ReactComponent };